import {newsApi} from './api';

export const StatementService = newsApi.injectEndpoints({
    endpoints: (build) => ({
        getStatements: build.query({
            query: ({id, pagination}) => ({
                url: `statements/get${id}${pagination && pagination}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            providesTags: ['Driver'],
        }),
        getStatementsJobs: build.query({
            query: ({id, pagination}) => ({
                url: `statements/jobs/${id}${pagination && pagination}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            providesTags: ['Driver'],
        }),
        addStatement: build.mutation({
            query: (form) => ({
                url: `statements/store`,
                method: 'POST',
                body: form,
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
        editStatement: build.mutation({
            query: ({id, newForm}) => ({
                url: `statements/update/${id}`,
                method: 'POST',
                body: newForm,
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
        removeStatement: build.mutation({
            query: (id) => ({
                url: `statements/delete/${id}`,
                method: 'DELETE',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
    }),
    overrideExisting: false,
})

export const {
    useGetStatementsQuery,
    useGetStatementsJobsQuery,
    useAddStatementMutation,
    useEditStatementMutation,
    useRemoveStatementMutation,
} = StatementService